const QrCode = ({ qrCode }: any) => {
  return (
    <img style={{ width: '272px', height: '274px' }} src={'data:image/svg+xml;base64,' + qrCode} alt={'qr-code'} />
  );
};

export default QrCode;
